<template>
    <div>
        <!-- <div class="member-profile-selection">
            <label class="label-profile-selection">Select Related Member Profile*</label>
            <div class="d-flex flex-wrap" style="gap: 1em;">
                <Multiselect
                    trackBy="id"
                    label="value"
                    class="position-relative w-50"
                    :searchable="true"
                    :showLabels="false"
                    placeholder="Search Profile.."
                    v-model="selectedProfile"
                    :options="companyProfileOptions"
                    @select="handleProfileSelected"
                >
                    <span slot="noResult" class="text-no-profile-found">No profile found</span>
                </Multiselect>
                <span v-if="selectedProfile" class="material-symbols-outlined btn-profile-clear" title="Clear Selection" @click="clear()">close</span>
            </div>
        </div> -->
        <!-- <div class="member-profile-selection" v-if="userIsSuperAdmin()==true" >
            <label class="label-profile-selection">Select Dashboard*</label>
            <div class="d-flex flex-wrap" style="gap: 1em;">
                <Multiselect
                    trackBy="id"
                    label="value"
                    class="position-relative w-50"
                    :searchable="true"
                    :showLabels="false"
                    placeholder="Search Dashboard.."
                    v-model="selectedDashboard"
                    :options="allDashboardList"
                    @select="handleDashboardSelected"
                >
                    <span slot="noResult" class="text-no-profile-found">No Dashboard found</span>
                </Multiselect>
                <span v-if="selectedDashboard" class="material-symbols-outlined btn-profile-clear" title="Clear Selection" @click="clear()">close</span>
            </div>
        </div> -->
        <div v-if="userIsSuperAdmin()" class="client-general-info">
            <h2>Assign Dashboard</h2>
            <div class="mt-3">
                <span class="d-flex gap-1 my-3">
                    <h3>Configure for Old Apk versions</h3>
                    <span class="add-new-app-label" style="color: #848484"
                        >(Supports versions upto MobexHealth Community: 1.15.0 & MHH: 1.18.0)</span
                    >
                </span>
                <div class="d-flex flex-column w-30 pb-4">
                    <label for="clientDemographicsChosenTheme" class="class-label">Choose Dashboard</label>
                    <Multiselect
                        id="clientDemographicsChosenTheme"
                        track-by="id"
                        label="name"
                        class="position-relative w-100"
                        placeholder="Select Dashboard"
                        v-model="dashboardUsed"
                        :options="allDashboardList"
                        :searchable="true"
                        :show-labels="false"
                        @input="handleDashboard($event, 'dashboardUsed')"
                    />
                </div>
                <span class="class-label mt-2"
                    >Note: If nothing is selected,oldest MHH dashboard will be assigned automatically
                </span>
            </div>
            <div class="mt-2">
                <h3 class="my-3">Configure for New Apk versions</h3>
                <div class="d-flex flex-wrap mt-2 w-100">
                    <div class="mb-3 d-flex flex-column justify-content-center w-30 mr-3">
                        <label for="kiosk" class="class-label">MobexHealth Community</label>
                        <Multiselect
                            id="kiosk"
                            track-by="id"
                            label="name"
                            class="position-relative w-100"
                            placeholder="Select Dashboard"
                            v-model="kiosk_dashboard_used"
                            :options="kioskDashboardList"
                            :searchable="true"
                            :show-labels="false"
                            @input="handleDashboard($event, 'kiosk_dashboard_used')"
                        />
                    </div>
                    <div class="mb-3 d-flex flex-column justify-content-center w-30 mx-3">
                        <label for="mhh" class="class-label">MobexHealth Hub</label>
                        <Multiselect
                            id="mhh"
                            track-by="id"
                            label="name"
                            class="position-relative w-100"
                            placeholder="Select Dashboard"
                            v-model="mhh_dashboard_used"
                            :options="mhhDashbordList"
                            :searchable="true"
                            :show-labels="false"
                            @input="handleDashboard($event, 'mhh_dashboard_used')"
                        />
                    </div>
                    <div class="mb-3 d-flex flex-column justify-content-center w-30 ml-3">
                        <label for="fc" class="class-label">Family Connect</label>
                        <Multiselect
                            id="fc"
                            track-by="id"
                            label="name"
                            class="position-relative w-100"
                            placeholder="Select Dashboard"
                            v-model="family_connect_dashboard_used"
                            :options="fcDashbordList"
                            :searchable="true"
                            :show-labels="false"
                            @input="handleDashboard($event, 'family_connect_dashboard_used')"
                        />
                    </div>
                    <div v-if="isMainCompany" class="mb-3 d-flex flex-column justify-content-center w-30 mr-3">
                        <label for="star-kid" class="class-label">STAR Kids</label>
                        <Multiselect
                            id="star-kid"
                            track-by="id"
                            label="name"
                            class="position-relative w-100"
                            placeholder="Select Dashboard"
                            v-model="star_kid_dashboard_used"
                            :options="starkidDashboardList"
                            :searchable="true"
                            :show-labels="false"
                            @input="handleDashboard($event, 'star_kid_dashboard_used')"
                        />
                    </div>
                    <div class="mb-3 d-flex flex-column justify-content-center w-30 mx-3">
                        <label for="mhp" class="class-label">MobexHealth Plus</label>
                        <Multiselect
                            id="mhp"
                            track-by="id"
                            label="name"
                            class="position-relative w-100"
                            placeholder="Select Dashboard"
                            v-model="mobex_plus_dashboard_used"
                            :options="mhpDashboardList"
                            :searchable="true"
                            :show-labels="false"
                            @input="handleDashboard($event, 'mobex_plus_dashboard_used')"
                        />
                    </div>
                    <div class="mb-3 d-flex flex-column justify-content-center w-30 ml-3">
                        <label for="mhp" class="class-label">MobexHealth Home</label>
                        <Multiselect
                            id="mhhh"
                            track-by="id"
                            label="name"
                            class="position-relative w-100"
                            placeholder="Select Dashboard"
                            v-model="mobex_health_home_dashboard_used"
                            :options="healthHomeDashboardList"
                            :searchable="true"
                            :show-labels="false"
                            :disabled="!userIsSuperAdmin"
                            @input="handleDashboard($event, 'mobex_health_home_dashboard_used')"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="userIsSuperAdmin()" class="client-general-info">
            <h2>Assign Project Tags</h2>
            <div class="mt-3">
                <div class="d-flex flex-column w-50 pb-4">
                    <label for="clientDemographicsChosenTheme" class="class-label">Choose Tags</label>
                    <Multiselect
                        id="clientDemographicsChosenTheme"
                        track-by="id"
                        label="name"
                        placeholder="Search or Select Tags"
                        v-model="generalInfo.tags"
                        :options="tagsList"
                        :searchable="true"
                        :show-labels="false"
                        :multiple="true"
                        :clear-on-select="false"
                        :close-on-select="false"
                    />
                </div>
            </div>
        </div>
        <div class="client-general-info">
            <ValidationObserver ref="form">
                <form>
                    <div>
                        <div class="fullwidth d-flex align-items-center bottom-20">
                            <span class="client-dependant-toggle-text">Member is a dependent</span>
                            <Toggle
                                class="toggle-switch"
                                v-model="is_client_dependant"
                                @input="noClientEmailBtn = false"
                                :labelClass="'switch'"
                                :spanClass="'slider'"
                                id="is_client_dependant_toggle_button"
                            />
                            <span class="client-dependant-toggle-text ms-3">
                                {{ is_client_dependant ? 'Yes' : 'No' }}</span
                            >
                        </div>
                        <template v-if="is_client_dependant">
                            <div class="flex colx4 space-between bottom-15">
                                <Input
                                    label="Parent / Guardian First Name"
                                    type="text"
                                    name="Parent / Guardian First Name"
                                    class="field-container"
                                    :required="is_client_dependant"
                                    v-model="contactInfo.guardian.firstName"
                                    inputClass="input-add-new-client"
                                    labelClass="class-label"
                                />
                                <Input
                                    label="Parent / Guardian Last Name"
                                    type="text"
                                    name="Parent / Guardian Last Name"
                                    class="field-container"
                                    :required="is_client_dependant"
                                    v-model="contactInfo.guardian.lastName"
                                    inputClass="input-add-new-client"
                                    labelClass="class-label"
                                />
                                <Input
                                    label="Relationship to Member"
                                    type="text"
                                    name="Relationship to Client"
                                    class="field-container"
                                    :required="is_client_dependant"
                                    v-model="contactInfo.guardian.relationshipToClient"
                                    inputClass="input-add-new-client"
                                    labelClass="class-label"
                                />
                                <div>
                                    <Input
                                        label="Guardian Email"
                                        type="email"
                                        name="Email"
                                        id="guardianloginEmailInput"
                                        class="margin-0 flex-1 position-relative"
                                        rules="email"
                                        :required="is_client_dependant"
                                        v-model="generalInfo.guardian_email"
                                        inputClass="input-add-new-client"
                                        labelClass="class-label"
                                    />
                                    <div class="toggle-guardian-no-email">
                                        <span class="toggle-label">No Email</span>
                                        <Toggle
                                            class="toggle-switch"
                                            :labelClass="'switch'"
                                            :spanClass="'slider'"
                                            id="guardian2email_alias"
                                            @input="(e) => guardian2email_alias(e)"
                                        />
                                    </div>

                                    <!-- <button
                                        class="primary nowrap margin-0 left-15 no-email bottom-15"
                                        type="button"
                                        @click.prevent="guardian2email_alias"
                                    >
                                        No dependent email
                                    </button> -->
                                </div>
                            </div>

                            <div class="add-new-client-dependant-note flex center my-5">
                                <svg
                                    class="right-10"
                                    width="41"
                                    height="44"
                                    viewBox="0 0 41 44"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M20.4681 8.59885C17.1198 8.59855 13.917 9.96891 11.6049 12.3914C9.29326 14.8139 8.07408 18.077 8.2308 21.4218C8.38778 24.7667 9.9069 27.9013 12.4351 30.0969C14.3111 31.6673 15.3753 34.0021 15.3304 36.4483V36.7012C15.331 37.2645 15.5436 37.8071 15.9265 38.221C16.3091 38.6346 16.8331 38.889 17.3949 38.9337V40.4C17.3949 41.4976 17.9807 42.5121 18.9314 43.0611C19.8821 43.6098 21.0536 43.6098 22.0043 43.0611C22.955 42.5121 23.5408 41.4976 23.5408 40.4V38.9337C24.1026 38.889 24.6267 38.6346 25.0093 38.221C25.3922 37.8071 25.6047 37.2645 25.6054 36.7012V36.4483C25.5604 34.0021 26.6247 31.6673 28.5006 30.0969C31.0288 27.9012 32.5479 24.7667 32.7049 21.4218C32.8616 18.0771 31.6425 14.8141 29.3308 12.3914C27.0192 9.96891 23.8163 8.59854 20.4676 8.59885H20.4681ZM20.4681 41.9327C20.0619 41.9321 19.6723 41.7706 19.385 41.4833C19.0977 41.1958 18.9362 40.8062 18.9359 40.3999V38.9406H22.0006V40.3999H22.0003C22 40.8062 21.8385 41.1957 21.5513 41.4833C21.264 41.7706 20.8745 41.9321 20.4681 41.9327ZM24.0658 36.7008C24.0651 37.0871 23.7521 37.3998 23.3658 37.4004H17.5704C17.1841 37.3998 16.8711 37.0871 16.8705 36.7008V36.4479C16.8714 35.8388 16.8195 35.2306 16.7147 34.6306H24.2215C24.1167 35.2306 24.0648 35.8388 24.0657 36.4479L24.0658 36.7008ZM27.4906 28.9341L27.4903 28.9338C26.1874 30.0446 25.199 31.4778 24.6233 33.0905H16.3127C15.737 31.4778 14.7486 30.0446 13.4457 28.9338C11.2351 27.0145 9.90698 24.2738 9.7697 21.3493C9.63242 18.4249 10.6982 15.5718 12.7193 13.4539C14.7404 11.3359 17.5404 10.1374 20.4678 10.1374C23.3953 10.1374 26.1953 11.3359 28.2164 13.4539C30.2374 15.5718 31.3033 18.4249 31.166 21.3493C31.0287 24.2738 29.7005 27.0145 27.49 28.9338L27.4906 28.9341ZM19.6978 5.61084L19.6975 1.62876C19.6975 1.20334 20.0424 0.858398 20.4679 0.858398C20.8933 0.858398 21.2382 1.20334 21.2382 1.62876V5.61084V5.61053C21.2382 6.03595 20.8933 6.38089 20.4679 6.38089C20.0424 6.38089 19.6975 6.03595 19.6975 5.61053L19.6978 5.61084ZM10.2376 31.0788C10.5379 31.3797 10.5379 31.8671 10.2376 32.168L7.42182 34.9838C7.27971 35.1377 7.08082 35.227 6.87161 35.2313C6.66209 35.2355 6.45986 35.1541 6.31168 35.0063C6.16351 34.8581 6.08182 34.6561 6.08577 34.4466C6.08972 34.2371 6.17899 34.0385 6.33264 33.8961L9.14956 31.0789C9.45048 30.7795 9.93662 30.7795 10.2375 31.0789L10.2376 31.0788ZM34.6033 6.7131C34.7478 6.85734 34.8289 7.05319 34.8289 7.25724C34.8289 7.4616 34.7478 7.65745 34.6033 7.80168L31.7864 10.618C31.6427 10.7662 31.4457 10.8506 31.2392 10.8521C31.0327 10.8539 30.8344 10.7725 30.6884 10.6265C30.5426 10.4807 30.4612 10.2821 30.4628 10.076C30.4646 9.8695 30.5487 9.67243 30.6972 9.5288L33.5129 6.71335C33.6572 6.56851 33.8533 6.48683 34.058 6.48683C34.2626 6.48683 34.4588 6.56826 34.6033 6.7131ZM6.0003 20.8482C5.99999 21.2734 5.65535 21.618 5.22994 21.618H1.24817C1.04047 21.6232 0.839765 21.5442 0.691277 21.3994C0.54279 21.2542 0.458984 21.0556 0.458984 20.8479C0.458984 20.6405 0.54279 20.4417 0.691277 20.2968C0.839765 20.1517 1.04047 20.073 1.24817 20.0779H5.23025H5.22995C5.65536 20.0779 6.0003 20.4228 6.0003 20.8482ZM40.459 20.8482C40.4587 21.2734 40.114 21.618 39.6886 21.618H35.7066H35.7069C35.4992 21.6232 35.2985 21.5442 35.15 21.3994C35.0015 21.2542 34.9177 21.0556 34.9177 20.8479C34.9177 20.6405 35.0015 20.4417 35.15 20.2968C35.2985 20.1517 35.4992 20.073 35.7069 20.0779H39.6889H39.6886C40.114 20.0779 40.459 20.4228 40.459 20.8482ZM34.6038 33.8959C34.8965 34.198 34.8928 34.679 34.5953 34.9766C34.298 35.2738 33.8167 35.2778 33.5146 34.9851L30.6988 32.1693C30.4058 31.8675 30.4089 31.3862 30.7058 31.0883C31.0031 30.7905 31.4841 30.7862 31.7868 31.0786L34.6038 33.8959ZM6.33113 7.80371H6.33144C6.03082 7.50279 6.03082 7.01541 6.33144 6.7145C6.63235 6.41389 7.12005 6.41419 7.42064 6.71481L10.2364 9.53025C10.5051 9.83512 10.4912 10.2964 10.2039 10.5839C9.91697 10.8715 9.45572 10.8867 9.15023 10.6186L6.33113 7.80371Z"
                                        fill="black"
                                    />
                                </svg>
                                <div class="tips-client-dependant">
                                    <span>Note:</span> If dependent does not have their own email address, utilize the
                                    "No dependent email" button. If the dependent has their own email separate to the
                                    guardian email, enter below in Member Email.
                                </div>
                            </div>
                        </template>

                        <!-- Client status* - editable drop down -->
                        <div class="flex colx4 space-between bottom-30">
                            <Dropdown
                                name="Client Status"
                                id="the_import_statusDropdown"
                                label="Member Status"
                                :options="statusOptions"
                                required
                                placeholder="---- Select ----"
                                v-model="generalInfo.status"
                                :value="generalInfo.status"
                                labelClass="class-label"
                            />
                            <!-- First Name* - editable -->
                            <Input
                                label="First Name"
                                type="text"
                                name="First Name"
                                id="firstNameInput"
                                required
                                v-model="generalInfo.firstName"
                                inputClass="input-add-new-client"
                                labelClass="class-label"
                                placeholder="First Name"
                            />
                            <!-- Last Name* - editable -->
                            <Input
                                label="Last Name"
                                type="text"
                                name="Last Name"
                                id="lastNameInput"
                                required
                                v-model="generalInfo.lastName"
                                inputClass="input-add-new-client"
                                labelClass="class-label"
                                placeholder="Last Name"
                            />
                            <!-- Primary Phone* - editable numeric phone number -->
                            <Input
                                label="Primary Phone"
                                type="text"
                                name="Primary Phone"
                                id="clientPrimaryPhoneInput"
                                rules="phone"
                                placeholder="Primary Phone"
                                v-model="generalInfo.phone"
                                inputClass="input-add-new-client"
                                labelClass="class-label"
                            />
                        </div>
                    </div>
                    <div class="flex colx5 bottom-15 align-top">
                        <div class="flex-2 position-relative">
                            <Input
                                label="Member Email"
                                type="email"
                                name="Email"
                                id="loginEmailInput"
                                rules="email"
                                v-model="generalInfo.email"
                                inputClass="input-add-new-client"
                                labelClass="class-label"
                                placeholder="Member Email"
                                required
                            />
                            <div v-if="!is_client_dependant" class="toggle-client-no-email">
                                <span class="toggle-label">No Email</span>
                                <Toggle
                                    class="toggle-switch"
                                    :labelClass="'switch'"
                                    :spanClass="'slider'"
                                    id="email_alias"
                                    v-model="noClientEmailBtn"
                                    @input="(e) => email_alias(e)"
                                />
                            </div>
                            <span class="block dark-red font-13 weight-600">{{ noButtonError }}</span>

                            <!-- <button v-if="!is_client_dependant"
                                class="primary space-l nowrap no-email"
                                type="button"
                                @click.prevent="email_alias"
                            >
                                No Email
                            </button> -->
                        </div>
                        <!-- Street Address* - editable text field -->
                        <Input
                            label="Street Address"
                            type="text"
                            name="Street Address"
                            id="clientStreetAddressInput"
                            class="flex-3 marg-r space-l"
                            v-model="generalInfo.streetAddress"
                            inputClass="input-add-new-client"
                            labelClass="class-label"
                            placeholder="Street Address"
                        />

                        <!-- City* - editable text field -->
                        <Input
                            label="City"
                            type="text"
                            name="City"
                            id="clientCityInput"
                            class="flex-1 space-l"
                            v-model="generalInfo.city"
                            inputClass="input-add-new-client"
                            labelClass="class-label"
                            placeholder="City"
                        />

                        <!-- State* - editable drop down with state initials -->
                        <Dropdown
                            label="State"
                            name="State"
                            id="clientStateDropdown"
                            class="flex-1 space-l"
                            :options="stateInitials"
                            placeholder="---- Select ----"
                            v-model="generalInfo.state"
                            labelClass="class-label"
                        />

                        <!-- Zip* - editable 5 digit numeric -->
                        <Input
                            label="Zip"
                            type="text"
                            name="Zip"
                            id="clientZipInput"
                            class="flex-1 space-l"
                            v-model="generalInfo.zip"
                            inputClass="input-add-new-client"
                            labelClass="class-label"
                            placeholder="Zip"
                        />
                    </div>
                </form>
            </ValidationObserver>
        </div>
        <div class="d-flex justify-content-end mt-4">
            <button type="button" class="primary btn-add-new-client" @click="submit()">Add Member Details</button>
        </div>
        <Loading v-if="showLoader" />
    </div>
</template>
<script>
    import { ValidationObserver } from 'vee-validate';
    import { statusOptions, stateInitials } from '@/util/options';
    import { clients, memberProfile, dashboardBuilder, companies } from '@/util/apiRequests';
    import Loading from '@/components/general/loading/loading.vue';
    import { Roles } from '@/util/globalConstants';
    const initialGeneralInfo = {
        status: 'Active',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        streetAddress: '',
        city: '',
        state: '',
        dob: '',
        gender: '',
        guardian_email: '',
        ageGroup: null,
        clientProfile: null,
        dashboardUsed: null,
        kiosk_dashboard_used: null,
        mhh_dashboard_used: null,
        family_connect_dashboard_used: null,
        star_kid_dashboard_used: null,
        mobex_plus_dashboard_used: null,
        mobex_health_home_dashboard_used: null,
        tags: [],
    };
    const initialContactInfo = {
        guardian: {
            firstName: '',
            lastName: '',
            relationshipToClient: '',
            email: '',
        },
    };

    export default {
        components: {
            ValidationObserver,
            Loading,
        },
        name: 'AddNewClient',
        data() {
            return {
                Roles,
                showLoader: false,
                profileList: [
                    { id: 1, age_group: 'child', profile_name: 'Test deseage' },
                    { id: 2, age_group: 'adult', profile_name: 'Test cancer' },
                    { id: 3, age_group: 'older', profile_name: 'Test pnemonia' },
                    { id: 4, age_group: 'adult', profile_name: 'Test covid' },
                    { id: 5, age_group: 'child', profile_name: 'Test deseage2' },
                    { id: 6, age_group: 'older', profile_name: 'Test deseage3' },
                ],
                companyProfileOptions: [],
                selectedProfile: null,
                generalInfo: { ...initialGeneralInfo },
                contactInfo: { ...initialContactInfo },
                is_client_dependant: false,
                statusOptions,
                stateInitials,
                noClientEmailBtn: false,
                noButtonError: '',
                dashboardCreated: [],
                selectedDashboard: null,
                dashboardUsed: '',
                kiosk_dashboard_used: '',
                mhh_dashboard_used: '',
                family_connect_dashboard_used: '',
                star_kid_dashboard_used: '',
                mobex_plus_dashboard_used: '',
                mobex_health_home_dashboard_used: '',
                allDashboardList: [],
                kioskDashboardList: [],
                mhhDashbordList: [],
                fcDashbordList: [],
                starkidDashboardList: [],
                mhpDashboardList: [],
                healthHomeDashboardList: [],
                tagsList: [],
                countryCode: '+1',
            };
        },
        methods: {
            userIsSuperAdmin() {
                if (this.$store.state.user.role_id == Roles.SUPER_ADMIN) {
                    return true;
                } else return false;
            },
            handleProfileSelected(e) {
                this.generalInfo.clientProfileName = e.value;
                this.generalInfo.clientProfile = e.id;
                this.generalInfo.ageGroup = e.theme;
            },
            clear() {
                this.selectedProfile = null;
                (this.generalInfo.clientProfileName = null), (this.generalInfo.clientProfile = null);
                this.generalInfo.ageGroup = null;
                this.generalInfo.dashboardUsed = null;
            },
            async fetchCompanyProfiles() {
                try {
                    this.showLoader = true;
                    let result = await this.$api.get(memberProfile.getMemberProfileList());
                    if (result?.data?.data) {
                        this.companyProfileOptions = result.data.data.map((item) => {
                            return {
                                id: item.id,
                                disabled: false,
                                value: item.profile_name,
                                theme: item.age_group,
                            };
                        });
                    }
                } catch (e) {
                    console.log('Failed to get company profiles', e);
                } finally {
                    this.showLoader = false;
                }
            },
            dropdownChangeHandler({ id, value, theme }) {
                this.generalInfo.clientProfileName = value;
                this.generalInfo.clientProfile = id;
                this.generalInfo.ageGroup = theme;
            },

            async fetchDashboardListforMHH() {
                try {
                    let result = await this.$api.get(dashboardBuilder.getTemplateList('completed'));
                    if (result?.data?.templateMetaList) {
                        this.dashboardCreated = result.data.templateMetaList.filter((item) => {
                            if (item.application == 'mobex-health-hub') {
                                return {
                                    id: item.id,
                                    value: `${item.dashboardName}`,
                                };
                            }
                        });
                    }
                } catch (err) {
                    console.log('err', err);
                }
            },

            async submit() {
                // if (!this.generalInfo.dashboardUsed) {
                //     this.$toasted.error('Please Select Dashboard');
                //     return;
                // }

                const form = this.$refs.form;
                const isFormValid = await form.validate();
                if (!isFormValid) {
                    this.$toasted.error('Please fill all required fields');
                    return;
                }

                if (this.is_client_dependant) {
                    // this.generalInfo.guardian_email = this.generalInfo.email
                    this.contactInfo.guardian.email = this.generalInfo.guardian_email;
                    // this.generalInfo.email = await this.$email_alias(this.generalInfo.guardian_email, this.generalInfo.firstName)
                } else {
                    this.generalInfo.guardian_email = '';
                    this.contactInfo.guardian.email = this.generalInfo.guardian_email; // yes redundant - but leave here until bm-981 is done - afv
                }

                try {
                    this.showLoader = true;

                    if (this.generalInfo.dashboardUsed == null) {
                        if (this.dashboardCreated.length > 0) {
                            this.generalInfo.dashboardUsed = this.dashboardCreated[0].id;
                            if (this.generalInfo.mhh_dashboard_used == null) {
                                this.generalInfo.mhh_dashboard_used = this.dashboardCreated[0].id;
                            }
                        }
                    }

                    if (this.generalInfo?.email) {
                        this.generalInfo.email = this.generalInfo?.email.toLowerCase().trim();
                    }

                    let phone = this.generalInfo.phone;

                    if (this.generalInfo.phone) {
                        phone = (!phone.startsWith('+') ? this.countryCode : '') + phone;
                    }

                    let result = await this.$api.post(clients.createClient(), { ...this.generalInfo, phone });
                    if (result.status == 200) {
                        this.client_id = result.data[0];

                        if (this.is_client_dependant) {
                            await this.$api.put(
                                clients.updateContactDetailsByType(this.client_id, 'guardian'),
                                this.contactInfo.guardian
                            );
                        }
                        this.resetForm();

                        await this.$router.push({ name: 'ClientDemographics', params: { client_id: result.data[0] } });
                    } else if (result.status === 409) {
                        this.$toasted.error('This member has already been imported');
                    } else {
                        this.$toasted.error(result.data.error);
                    }
                } catch (error) {
                    this.$toasted.error('Failed to create client');
                } finally {
                    this.showLoader = false;
                }
            },
            resetForm() {
                // this.$refs.form.reset();
                // this.generalInfo.status = 'Active';
                this.is_client_dependant = false;
                this.generalInfo = { ...initialGeneralInfo };
                this.contactInfo = { ...initialContactInfo };
                requestAnimationFrame(() => {
                    this.$refs.form.reset();
                });
            },
            email_alias(value) {
                if (value) {
                    if (this.generalInfo?.firstName && this.generalInfo?.lastName) {
                        let temp_email = this.$email_alias(this.$store.state.user.email);
                        this.$set(this.generalInfo, 'email', temp_email);
                        this.noButtonError = '';
                        this.$forceUpdate();
                    } else {
                        this.noClientEmailBtn = false;
                        this.noButtonError = 'Please add a first name or last name, then try again.';
                    }
                }
            },
            guardian2email_alias(value) {
                if (value) {
                    let temp_email = this.$email_alias(this.generalInfo.guardian_email);
                    this.$set(this.generalInfo, 'email', temp_email);
                    this.noButtonError = '';
                    this.$forceUpdate();
                }
            },
            fill_in_fields(data) {
                for (const [index, row] of Object.entries(data)) {
                    this.generalInfo[index] = data[index];
                }
            },
            async fetchDashboardList() {
                try {
                    let result = await this.$api.get(dashboardBuilder.getTemplateList('completed'));
                    if (result?.data?.templateMetaList) {
                        const allDashboardList = result.data.templateMetaList.map((dashboard) => {
                            return {
                                id: dashboard.id,
                                name: dashboard.dashboardName,
                                application: dashboard.application,
                            };
                        });

                        this.allDashboardList = [...allDashboardList];

                        this.kioskDashboardList = allDashboardList.filter(
                            (dashboard) => dashboard.application === 'kiosk'
                        );
                        this.mhhDashbordList = allDashboardList.filter(
                            (dashboard) => dashboard.application === 'mobex-health-hub'
                        );
                        this.fcDashbordList = allDashboardList.filter(
                            (dashboard) => dashboard.application === 'family-connect'
                        );
                        this.starkidDashboardList = allDashboardList.filter(
                            (dashboard) => dashboard.application === 'star-kid'
                        );
                        this.mhpDashboardList = allDashboardList.filter(
                            (dashboard) => dashboard.application === 'mobex-health-plus'
                        );
                        this.healthHomeDashboardList = allDashboardList.filter(
                            (dashboard) => dashboard.application === 'mobex-health-home'
                        );
                    }
                } catch (err) {
                    console.log('err', err);
                }
            },
            async handleDashboardSelected(e) {
                this.generalInfo.dashboardUsed = e.id;
            },
            handleDashboard(val, field) {
                this.generalInfo[field] = val?.id ?? null;
                if (!val) {
                    return;
                }
                if (val.application === 'kiosk') {
                    this.kiosk_dashboard_used = { ...val };
                    this.generalInfo.kiosk_dashboard_used = val.id;
                } else if (val.application === 'mobex-health-hub') {
                    this.mhh_dashboard_used = { ...val };
                    this.generalInfo.mhh_dashboard_used = val.id;
                } else if (val.application === 'family-connect') {
                    this.family_connect_dashboard_used = { ...val };
                    this.generalInfo.family_connect_dashboard_used = val.id;
                } else if (val.application === 'star-kid') {
                    this.star_kid_dashboard_used = { ...val };
                    this.generalInfo.star_kid_dashboard_used = val.id;
                } else if (val.application === 'mobex-health-plus') {
                    this.mobex_plus_dashboard_used = { ...val };
                    this.generalInfo.mobex_plus_dashboard_used = val.id;
                } else if (val.application === 'mobex-health-home') {
                    this.mobex_health_home_dashboard_used = { ...val };
                    this.generalInfo.mobex_health_home_dashboard_used = val.id;
                }
            },
            async fetchTags() {
                try {
                    let res = await this.$api.get(companies.getTags(this.$store.state.user.company_id));
                    if (res.data.success) {
                        this.tagsList = res.data.info;
                    }
                } catch (err) {
                    console.log('err', err);
                }
            },
            getUserCountryCode() {
                const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                if (timeZone.startsWith('Asia')) {
                    this.countryCode = '+91';
                    return;
                }

                this.countryCode = '+1';
            },
        },
        async created() {
            await this.fetchCompanyProfiles();
            await this.fetchDashboardList();
            await this.fetchTags();
            await this.fetchDashboardListforMHH();
            this.getUserCountryCode();
        },
        computed: {
            userAllowedEdit: () => {
                // TODO: check user permissions
                return true;
            },
            payload() {
                return this.$store.state.newResourceModal.new_client_data;
            },
            isMainCompany() {
                return Number(process.env.VUE_APP_mobex_plus_company_id) === this.$store.state.user.company_id;
            },
            // ...mapState(
            //     {
            //         payload:"newResourceModal/new_client_data"
            //     }
            // )
        },
        watch: {
            payload: {
                deep: true,
                async handler() {
                    if (this.payload.new_hit && this.payload.new_hit > 0) {
                        this.payload.new_hit = 0;
                        this.fill_in_fields(this.payload);
                        this.$store.commit('newResourceModal/openNewClientModal2', { new_hit: 0 });
                    }
                },
            },
        },
    };
</script>

<style scoped>
    .assign-dashboard-btn {
        border-radius: 5px;
    }
</style>
